<div class="settings-row-label">
    <slot />
</div>

<style>
    .settings-row-label {
        font-size: 1.2em;
        /*margin-bottom: 10px;*/
        flex: 0.5 0 200px;
    }
</style>